/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Breakpoint } from 'react-socks';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import { Link } from 'react-router-dom';
import * as _ from 'underscore';
import PostAnalysisModal from 'app/components/CreateFeed/PostAnalysisModal.jsx';
import ReuseSocialInputModal from 'app/components/InputModal/ReuseSocialInputModal.jsx';
import FeatureCallout from 'app/components/common/FeatureCallout.jsx';

class ChooseFeedType extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            areSocialTilesVisible: false,
            externalServiceClicked: false,
            crossPostType: 0
        };

        this.socialRef = React.createRef();

        this.onTileClick = this.onTileClick.bind(this);
        this.oauthConnector = this.oauthConnector.bind(this);

    }

    componentDidMount() {
        let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
            isOnboarding = (onboarding === null) ? false : true,
            constants = this.props.app.config.constants;


        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Input Tiles View'
            });
        }

        if (mixpanel) {
            mixpanel.track("Input Tiles View", {
                onboarding: isOnboarding,
            });
        }

        if (dataLayer) {
            dataLayer.push({
                'event': 'input-tiles-view',
                'onboarding': isOnboarding
            });
        }

        if (this.props.router.params && this.props.router.params.inputType !== undefined) {
            let type = 0,
                subType = 0,
                crossPostType = 0;

            switch (this.props.router.params.inputType) {
                case "feed":
                    type = 'feed_search_tile';
                    break;

                case "instagram":
                    type = 'cross_post';
                    crossPostType = constants.INPUT_TYPE_INSTAGRAM_BUSINESS;
                    break;

                case "facebook":
                    type = 'cross_post';
                    crossPostType = constants.INPUT_TYPE_FACEBOOK_PAGE;
                    break;

                case "youtube":
                    subType = constants.INPUT_SUBTYPE_YOUTUBE;
                    break;

                case "pinterest":
                    subType = constants.INPUT_SUBTYPE_PINTEREST;
                    break;

                default:
                    break;
            }

            this.onTileClick({
                currentTarget: {
                    dataset: {
                        type: type,
                        subtype: subType,
                        crossPostType: crossPostType,
                        oauth: false
                    }
                }
            });
        }

        if (this.props.router.query && this.props.router.query.social !== undefined && this.props.router.query.social === "true") {
            this.onTileClick({
                currentTarget: {
                    dataset: {
                        type: 'cross_post',
                        subType: 0,
                        oauth: false
                    }
                }
            });
            //window.scrollTo(0, this.socialRef.current.offsetTop);
        }

        if (this.props.router.query && this.props.router.query.feed !== undefined && this.props.router.query.feed === "true") {
            this.onTileClick({
                currentTarget: {
                    dataset: {
                        type: 'feed_search_tile',
                        subType: 0,
                        oauth: false
                    }
                }
            });

        }

    }

    oauthConnector(service, input) {
        let url = '/remote/begin?fx=auth&isID=:isId&state=:state&final=:final',
            date = new Date(),
            state = ['INPUT', service, date.getTime()].join('_'),
            constants = this.props.app.config.constants;

        if (input && input.sysActionFlag) {
            if (input.iID !== undefined && input.iID) {
                url = `/remote/beginreauth?isID=${input.iType}&iaID=${input.iID}&state=:state&final=:final`;
                state = ['REAUTHREUSE', input.iType, input.iID, service, date.getTime()].join('_');
            } else if (input.paID !== undefined && input.paID) {
                url = `/remote/beginreauth?psID=${input.paSvcID}&paID=${input.paID}&state=:state&final=:final`;
                state = ['REAUTHREUSE', input.paSvcID, input.paID, service, date.getTime()].join('_');
            }

        } else {
            url = url.replace(':isId', service);
        }

        if (service == constants.INPUT_TYPE_TWITTER) {
            if (this.props.user.perms.resources.inputTwitter === 0) {
                this.props.showUpgradeModal(this.props.closeAllModals, 'twitterInput', null, this.props.context + '_create');
                return;
            }
        }

        url = url.replace(':state', state);
        url = url.replace(':final', window.encodeURIComponent(window.location.href));

        window.location.assign(url);

    }

    onTileClick(e) {
        let type = parseInt(e.currentTarget.dataset.type, 10),
            subtype = parseInt(e.currentTarget.dataset.subtype, 10),
            crossPostType = parseInt(e.currentTarget.dataset.crossPostType, 10),
            oauth = e.currentTarget.dataset.oauth,
            code = (subtype) ? subtype : type,
            serviceName = '',
            onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
            isOnboarding = (onboarding === null) ? false : true,
            constants = this.props.app.config.constants;

        if (this.state.externalServiceClicked) {
            return;
        }

        if (isNaN(crossPostType)) {
            crossPostType = 0;
        }

        // clear out any previous validation errors when a new tile is clicked
		this.props.deleteApiError(['INPUT_VALIDATE', 'FEED_SEARCH', 'FEED_VALIDATE']);

        if (isNaN(type) && e.currentTarget.dataset.type === 'wordpress') {
            type = 'wordpress';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'feed_search_tile') {
            type = 'feed_search_tile';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'website_tile') {
            type = 'website_tile';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'create_post') {
            type = 'create_post';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'cross_post') {
            type = 'cross_post';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'post_analyzer') {
            type = 'post_analyzer';
        } else if (isNaN(type) && e.currentTarget.dataset.type === 'ai_helper') {
            type = 'ai_helper';
        }

        // TODO: remove the post_analysis check when it's real
        if (this.props.user.perms.resources.inputsAvailable === 0 && type !== 'post_analyzer') {
			this.props.showUpgradeModal(this.props.closeAllModals, 'inputs', null, 'Input Tiles');
            return;
		}

        serviceName = ConstantMixin.getInputServiceByCode(code);

        if (type === 'wordpress') {
            serviceName = 'wordpress';
        } else if (type === 'feed_search_tile') {
            serviceName = 'feed_search_tile';
        } else if (type === 'website_tile') {
            serviceName = 'website_tile';
        } else if (type === 'create_post') {
            serviceName = 'create_post';
        } else if (type === 'cross_post') {
            serviceName = 'cross_post';
        } else if (type === 'ai_helper') {
            serviceName = 'ai_helper';
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Input Tiles Click',
                event_data: {
                    service: serviceName
                }
            });
        }

        if (mixpanel) {
            mixpanel.track("Input Tiles Click", {
                onboarding: isOnboarding,
                service: serviceName
            });
        }

        if (dataLayer) {
            dataLayer.push({
                'event': 'input-tiles-click',
                'onboarding': isOnboarding,
                'service': serviceName
            });
        }

        if (type === constants.INPUT_TYPE_TWITTER) {
            if (this.props.user.perms.resources.inputTwitter === 0) {
                this.props.showUpgradeModal(this.props.closeAllModals, 'twitterInput', null, 'Input Tiles');
                return;
            }
        }

        if (e.preventDefault) {
            e.preventDefault();
        }

        if (oauth === "true") {
            if (this.props.automatedRoutes.socialInputCreds[type] !== undefined && this.props.automatedRoutes.socialInputCreds[type].length) {
                this.props.addModal(
                    <ReuseSocialInputModal
                        {...this.props}
                        service={type}
                        credList={this.props.automatedRoutes.socialInputCreds[type]}
                        newConnection={this.oauthConnector}
                        />
                );
            } else {
                this.oauthConnector(type);
                this.setState({
                    externalServiceClicked: true
                });
            }


        } else if (type === 'create_post') {
            this.props.router.navigate("/content/post");
        } else if (type === 'ai_helper') {
            this.props.router.navigate("/content/post?helper");
        } else if (_.isFunction(this.props.inputSelectCallback)) {
            this.props.inputSelectCallback(type, subtype, crossPostType);
        }

    }

    render() {
        let constants = this.props.app.config.constants,
            imgPath = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
            types = [
                {label: 'RSS Feed', type: 'website_tile', logo: imgPath + 'svg-logos/feed-blue.svg', oauth: false, alt: "Search for website content", extraClass: 'monochrome'},
                {label: 'Cross-Post', type: 'cross_post', logo: 'icon ion-android-share-alt', oauth: false, alt: "Cross-post content", extraClass: 'monochrome'},
                {label: 'Feed Search', type: 'feed_search_tile', logo: imgPath + 'svg-logos/search-blue.svg', oauth: false, alt: "Search for content", extraClass: 'monochrome'},
                {label: 'Create Post', type: 'create_post', logo: 'icon ion-edit', oauth: false, alt: "Create a Post", extraClass: 'monochrome'},
                {label: 'AI Helper', type: 'ai_helper', logo: 'icon ion-ios-color-wand', oauth: false, alt: "Create a Post with AI", extraClass: 'monochrome'},
                {label: 'YouTube', subtype: constants.INPUT_SUBTYPE_YOUTUBE, logo: imgPath + 'svg-logos/youtube.svg', oauth: false, alt: "Create YouTube Feed", extraClass: ''},
                {label: 'Pinterest', subtype: constants.INPUT_SUBTYPE_PINTEREST, logo: imgPath + 'svg-logos/pinterest.svg', oauth: false, alt: "Create Pinterest Feed", extraClass: ''},
                {label: 'WordPress', type: 'wordpress', logo: imgPath + 'svg-logos/wordpress.svg', oauth: false, alt: "Search Your WordPress Site", extraClass: ''},
                {label: 'Etsy', subtype: constants.INPUT_SUBTYPE_ETSY, logo: imgPath + 'svg-logos/etsy.svg', oauth: false, alt: "Create Etsy Feed", extraClass: ''},
                {label: 'Shopify', subtype: constants.INPUT_SUBTYPE_SHOPIFY, logo: imgPath + 'svg-logos/shopify.svg', oauth: false, alt: "Create Shopify Feed", extraClass: ''},
                {label: 'Substack', subtype: constants.INPUT_SUBTYPE_SUBSTACK, logo: imgPath + 'svg-logos/substack.svg', oauth: false, alt: "Create Substack Feed", extraClass: ''},
            ],
            instaTypes = [
                {label: 'Profile', type: constants.INPUT_TYPE_INSTAGRAM, logo: imgPath + 'svg-logos/instagram-grad.svg', oauth: true, alt: "Create Instagram Profile Feed"},
                {label: 'Professional', type: constants.INPUT_TYPE_INSTAGRAM_BUSINESS, logo: imgPath + 'svg-logos/instagram-purp.svg', oauth: true, alt: "Create Instagram Business or Creator Feed"}
            ],
            crossPostTypes = [
                {label: 'Connect Instagram', type: constants.INPUT_TYPE_INSTAGRAM_BUSINESS, logo: imgPath + 'svg-logos/instagram-purp.svg', oauth: true, alt: "Create Instagram Business or Creator Feed", extraClass: ''},
                {label: 'Connect Pages', type: constants.INPUT_TYPE_FACEBOOK_PAGE, logo: imgPath + 'svg-logos/facebook.svg', oauth: true, alt: "Create Facebook Page Feed", extraClass: 'narrow'},
            ],
            tileGenerator = (type) => {
                let dataType = (type.type) ? type.type : 0,
                    dataSubtype = (type.subtype) ? type.subtype : 0,
                    icon = null,
                    flair = null;

                if (type.logo.match(/icon|fa\b/)) {
                    icon = (
                        <i className={`${type.logo} tile-icon`}></i>
                    );
                } else {
                    icon = (
                        <img src={type.logo} width="50" height="50"/>
                    );
                }

                if (type.flair !== undefined && type.flair === true) {
                    flair = (
                        <div className="flair">
                            <i className="fa fa-star"/>
                        </div>
                    );
                }

                return (
                    <div key={[type.label.replace(" ", ""), dataType, dataSubtype].join("-")}
                            alt={type.alt}
                            className={"input-tile " + type.extraClass}
                            data-type={dataType} data-subtype={dataSubtype}
                            data-oauth={type.oauth}
                            onClick={this.onTileClick}
                            role="button"
                            aria-label={type.alt}>
                        {flair}
                        <div className="tile-img">
                            {icon}
                        </div>
                        <div className="tile-label">
                            {type.label}
                        </div>
                    </div>
                );
            },
            content = null,
            subhead = null,
            chevron = null;

        if (onboarding !== null ||
            this.props.user.perms.resources.inputTwitter === 0 ||
            (this.props.app.config.twitterDisabled !== undefined && parseInt(this.props.app.config.twitterDisabled) === 1)) {
            types = _.filter(types, (type) => {
                return type.type !== constants.INPUT_TYPE_TWITTER
            });
            // hard-code it for now
            crossPostTypes.splice(2, 1);
        }

        if ((parseInt(this.props.user.detail.id, 10) % 2) === 0) {
            subhead = (
                <div className="input-type-subhead">What content should we post?</div>
            );
        } else {
            subhead = (
                <div className="input-type-subhead">What content should we post?</div>
            );
        }

        if (this.state.areSocialTilesVisible) {
            chevron = (
                <i className="icon ion-chevron-up social-tiles-accordion"></i>
            );
        } else {
            chevron = (
                <i className="icon ion-chevron-down social-tiles-accordion"></i>
            );
        }

        if (this.props.inputType === 'cross_post') {
            if (this.props.crossPostType !== 0) {
                let socialLabel = ConstantMixin.getInputServiceByCode(this.props.crossPostType),
                    crossPostHeader = '';
                if (this.props.crossPostType === constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
                    crossPostHeader = 'Auto share Reels, Stories, and Photos from Instagram to other channels';
                } else if (this.props.crossPostType === constants.INPUT_TYPE_FACEBOOK_PAGE) {
                    crossPostHeader = 'Auto share Reels, Photos, and Links from Facebook to other channels.';
                }
                content = (
                    <div>
                        <div className="instagram-headline">
                            {crossPostHeader}
                        </div>
                        <div className="feed-chooser-wrapper">
                            <div className="tile-wrapper">
                                {crossPostTypes.map((type) => {
                                    if (type.type === this.props.crossPostType) {
                                        return tileGenerator(type);
                                    }
                                })}
                            </div>
                            <div className="choose-new-type padded">
                                <a href="#" onClick={this.props.returnToTiles} className="btn-primary reverse-fixed">
                                    {"<"} Go Back
                                </a>
                            </div>
                        </div>
                    </div>
                );
            } else {
                content = (
                    <div>
                        <div className="instagram-headline">
                            Want to share from Instagram or Facebook?
                        </div>
                        <div className="feed-chooser-wrapper">
                            <div className="tile-wrapper">
                                {crossPostTypes.map((type) => {
                                    return tileGenerator(type);
                                })}
                            </div>
                            <div className="choose-new-type padded">
                                <a href="#" onClick={this.props.returnToTiles} className="btn-primary reverse-fixed">
                                    {"<"} Go Back
                                </a>
                            </div>
                        </div>
                    </div>
                );
            }

        } else {
            content = (
                <div>
                    {subhead}
                    <Breakpoint mobile only>
                        <div className="feed-chooser-wrapper mobile">
                            <div className="tile-wrapper">
                                {types.slice(0, 12).map((type) => {
                                    return tileGenerator(type);
                                })}
                            </div>
                            <div className="feature-callout-wrapper">
                                <FeatureCallout
                                    {...this.props}
                                    onClick={() => {
                                        this.onTileClick({
                                            currentTarget: {
                                                dataset: {
                                                    type: "cross_post",
                                                    subtype: 0,
                                                    crossPostType: constants.INPUT_TYPE_INSTAGRAM_BUSINESS,
                                                    oauth: false
                                                }
                                            }
                                        });
                                    }}/>
                            </div>
                            <div className="popular-automations">
                                <Link to="/share/automations">
                                    See popular automations
                                </Link>
                            </div>
                        </div>
                    </Breakpoint>
                    <Breakpoint desktop only>
                        <div className="feed-chooser-wrapper">
                            <div className="tile-wrapper">
                                {types.slice(0, 5).map((type) => {
                                    return tileGenerator(type);
                                })}
                            </div>
                            <div className="tile-wrapper small">
                                {types.slice(5, 12).map((type) => {
                                    return tileGenerator(type);
                                })}
                            </div>
                            <div className="feature-callout-wrapper">
                                <FeatureCallout
                                    {...this.props}
                                    onClick={() => {
                                        this.onTileClick({
                                            currentTarget: {
                                                dataset: {
                                                    type: "cross_post",
                                                    subtype: 0,
                                                    crossPostType: constants.INPUT_TYPE_INSTAGRAM_BUSINESS,
                                                    oauth: false
                                                }
                                            }
                                        });
                                    }}/>
                            </div>
                            <div className="popular-automations">
                                <Link to="/share/automations">
                                    See popular automations
                                </Link>
                            </div>
                        </div>
                    </Breakpoint>
                </div>
            );
        }

        return content;

    }
}

ChooseFeedType.displayName = "ChooseFeedType";

ChooseFeedType.propTypes = {
    inputType: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    inputSelectCallback: PropTypes.func
};

ChooseFeedType.defaultProps = {
    inputType: 0,
    inputSelectCallback: null
};

export default ChooseFeedType;
